import { Button, Grid, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import { getType } from 'typesafe-actions';
import {
  ResponsiveCard,
  ResponsiveCardActions,
  ResponsiveCardContent,
} from '../../../../../../common/components/cards';
import { PasswordTextField } from '../../../../../../common/components/fields';
import { CenterAlign } from '../../../../../../common/components/layout';
import Logo from '../../../../../../common/components/Logo';
import { useQuery } from '../../../../../../common/utils/useQuery';
import { groupResetPasswordActions } from '../../../../groupVisits.actions';
import {
  resetPasswordInit,
  resetPasswordValidationSchema,
} from '../../../../groupVisits.dtos';

interface DetailParams {
  id: string;
}

const GroupVisitPasswordResetForm: React.FC<
  RouteComponentProps<DetailParams>
> = ({ match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  let query = useQuery();

  const groupId = match.params.id;
  const code = query.get('code');

  const onCancel = () => history.push(`/visit-login/${groupId}`);

  return (
    <CenterAlign>
      <ResponsiveCard>
        <Logo />
        <Formik
          initialValues={resetPasswordInit}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={resetPasswordValidationSchema}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              setTimeout(() => {
                setSubmitting(false);
              }, 700);

              values.groupVisitId = groupId;
              values.token = code ?? '';
              dispatch({
                type: getType(groupResetPasswordActions.request),
                payload: values,
              });
            }, 400);
          }}
        >
          {({ values, errors, isSubmitting, handleChange, handleSubmit }) => {
            return (
              <form
                onSubmit={(e) => {
                  handleSubmit();
                  e.preventDefault();
                }}
                noValidate
              >
                <ResponsiveCardContent>
                  <Typography variant='h6'>Reset Password</Typography>
                  <Typography variant='caption'>
                    Password must be 12 characters or longer with at least 1
                    uppercase letter, 1 lowercase letter, 1 number and 1 special
                    character.
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <PasswordTextField
                        label='Password'
                        fullWidth
                        name='password'
                        value={values.password}
                        onChange={handleChange}
                        required
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <PasswordTextField
                        label='Confirm password'
                        fullWidth
                        name='confirmPassword'
                        value={values.confirmPassword}
                        onChange={handleChange}
                        required
                        error={Boolean(errors.confirmPassword)}
                        helperText={errors.confirmPassword}
                      />
                    </Grid>
                  </Grid>
                </ResponsiveCardContent>

                <ResponsiveCardActions>
                  <Grid container justify='flex-end'>
                    <Button
                      className='orangeLink'
                      variant='text'
                      disabled={isSubmitting}
                      onClick={onCancel}
                      data-cy='cancel'
                    >
                      CANCEL
                    </Button>

                    <Button
                      color='secondary'
                      variant='text'
                      type='submit'
                      data-cy='resetPassword'
                      disabled={
                        isSubmitting ||
                        (values.confirmPassword === '' &&
                          values.password === '')
                      }
                    >
                      CHANGE PASSWORD
                    </Button>
                  </Grid>
                </ResponsiveCardActions>
              </form>
            );
          }}
        </Formik>
      </ResponsiveCard>
    </CenterAlign>
  );
};

export default GroupVisitPasswordResetForm;
